import React, { useState, useEffect, useContext } from 'react'
import { Button } from 'syngenta-react-components'
import DetailView from '../../../dpe-usco/components/Details/DetailView'
import SendForSigningForm from '../../../components/ModalForms/SendForSigningForm'
import useApiHelper from '../../../services/useApiHelper'
import { getContractById } from '../../../services/apiHelper'
import useQuery from '../../../services/useQuery'
import { GlobalContext } from '../../../services/context'
import { useParams } from 'react-router-dom'

const ContractPDFView = props => {
  const { dispatch, trackEvent } = useContext(GlobalContext)
  const { contract_id } = useParams()
  const [_contract_id] = useState(contract_id)
  const [contract_doc_link] = useState(useQuery().get('contract_doc_link'))
  const [grower_id, set_grower_id] = useState(useQuery().get('grower_id'))
  const [contractDataPending, setContractDataPending] =  useState('')
  const [
    { data: contractData, status },
    getContractByIdWithDraft
  ] = useApiHelper('getContractByIdWithDraft')
  const [showModal, setShowModal] = useState(false)
  const [disableSentSignBtn, setDisableSentSignBtn] = useState(false)
 
  useEffect(() => {
    getContractById(contract_id).then(res => {
      if(res) {
        setContractDataPending(res)
        set_grower_id(res.contract_details.grower_details.sap_id)
        
      }
    })
  },[contract_id])

  const handleClickSendForSigning = () => {
    setShowModal(true)
    trackEvent('send_for_signing_clicked', { contractId: contract_id })
  }

  const handleGoBack = () => {
    dispatch({ type: 'GO_BACK' })
  }

  useEffect(() => {
    let canceled = false
    const init = async () => {
      getContractByIdWithDraft(_contract_id)
    }
    if (_contract_id && !canceled) {
      init()
    }

    return () => {
      canceled = true
    }
  }, [_contract_id, getContractByIdWithDraft])

  useEffect(() => {
    if (!status) {
      if (!grower_id && contractData?.contract_details?.grower_details) {
        set_grower_id(contractData.contract_details.grower_details.sap_id)
      }
    }
  }, [contractData, grower_id, status])

  const detailViewButton = (
    contractData ? 
      <Button
        styleType="success"
        text="Send for signing"
        disabled={disableSentSignBtn}
        clickHandler={handleClickSendForSigning}
        customClassName="mb10"
      /> 
      :
      null
  )
  return (
    <DetailView button={detailViewButton}>
      <div className="pt20">
        {contract_doc_link && contract_doc_link !== 'null' ? (
          <>
            <object
              data={contract_doc_link}
              type="application/pdf"
              style={{ width: '100%', height: '75vh' }}
            >
              <p>This browser does not support PDFs.</p>
            </object>
            {detailViewButton}
          </>
        ) : (
          <>
            <p>Failed to retrieve the contract PDF</p>
            <Button
              styleType="success"
              text="Go Back"
              clickHandler={handleGoBack}
              customClassName="mb10"
            />
          </>
        )}
        {grower_id && (
          <div className="modalContainer" style={{ display: showModal ? 'block' : 'none' }}>
            <div className="aHModalChild posr t100" style={{ 'maxWidth': '900px' }}>
              <div className='w100% tal h100% bgc-white bd1-s-lightgray bxshmodal bdrs-4 mb40'>
                <SendForSigningForm
                  contract_id={contract_id}
                  contractDataPending={contractDataPending}
                  setShowModal={setShowModal}
                  contractData={contractData?contractData:contractDataPending}
                  growerDetails={contractData?contractData.contract_details.grower_details:contractDataPending.contract_details.grower_details}
                  resellerDetails={contractData?contractData.contract_details.reseller_details:contractDataPending.contract_details.reseller_details}
                  grainReceiverDetails={
                    contractData?contractData.contract_details.grain_receiver_details:contractDataPending.contract_details.grain_receiver_details
                  }
                  setDisableSentSignBtn = {setDisableSentSignBtn}
                />
              </div>
            </div>
          </div>
        )}
      </div>
      <></>
    </DetailView>
  )
}

export default ContractPDFView